import estilos from './Pastilla.module.css'

/**
 * Tonos disponibles. El significado es fijo en todo el sistema:
 *
 *   neutro    · existe pero todavía no se mueve
 *   marca     · en manos de alguien, avanzando
 *   compuerta · alguien tiene que decidir (es el naranja del anillo del logo)
 *   enCurso   · trabajo en campo
 *   cerrado   · terminado y conforme
 *   detenido  · rechazado, anulado o fuera de lo previsto
 */
export type TonoPastilla = 'neutro' | 'marca' | 'compuerta' | 'enCurso' | 'cerrado' | 'detenido'

type PropsPastilla = {
  children: string
  tono?: TonoPastilla
  /** El punto ayuda a distinguir estados a quien no diferencia bien los colores. */
  conPunto?: boolean
  titulo?: string
}

export function Pastilla({ children, tono = 'neutro', conPunto = true, titulo }: PropsPastilla) {
  return (
    <span className={`${estilos.pastilla} ${estilos[tono]}`} title={titulo}>
      {conPunto && <span className={estilos.punto} aria-hidden="true" />}
      {children}
    </span>
  )
}
